import React from "react";
import "./header.css";
import ME from "../../assets/me.png";
import HeaderSocial from "./HeaderSocial";
import ParticleBg from "./particleBg";

const Header = () => {
  return (
    <header>
      <section id="header">
        <div className="container header__container">
          <ParticleBg />
          <div className="me">
            <img src={ME} alt="me" />
          </div>
          <h5>Hello I'm</h5>
          <h1>Noer Rohim</h1>
          <h5 className="text-light">Junior Programmer</h5>
          <HeaderSocial />

          <a href="#footer" className="scroll__down">
            Scroll Down
          </a>
        </div>
      </section>
    </header>
  );
};

export default Header;
